import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const remove = (id) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "delete",
    url: `${baseUrl}/projects/${projectId}/receives/${id}`,
    needToken: true,
    data: id
  });
};

export const getSubjects = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/otherSubjects`,
    needToken: true,
    params: {
      paginate: false
    }
  });
};

export const storeSubject = (data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/otherSubjects`,
    needToken: true,
    data:data
  });
};

export const removeSubject = (id) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "delete",
    url: `${baseUrl}/projects/${projectId}/otherSubjects/${id}`,
    needToken: true,
  });
};

export const updateSubject = (id, data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: `${baseUrl}/projects/${projectId}/otherSubjects/${id}`,
    needToken: true,
    data: data
  });
};

export const store = (data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/receives`,
    needToken: true,
    data: data
  });
};

export const storeImage = (image , id) => {
  let formData = new FormData();
  formData.append('image', image);
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/receives/${id}/images`,
    needToken: true,
    headers: {
      'Content-Type': 'multipart/forms-data'
    },
    data:formData
  });
};
export const get = id => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/receives/${id}`,
    needToken: true,
  });
};

export const update = (id,data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: `${baseUrl}/projects/${projectId}/receives/${id}`,
    needToken: true,
    data: data
  });
};